module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "عزيزي-القارئ"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عزيزي القارئ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بين يديك قصّة لا مكان لها في الخريطة، ولا تُمثّل شخصيات واقعيَّة، وإنّما هي شخصيَّاتٌ من الخيال رسمَتْها الكاتبةُ في مخيّلتها وترجمَتْها على الورق، زمانُها زمان تملُّكِ الجواري، ذلك الزّمان الَّذي زادَت فيه الفتوحات والتوسّع العسكري، وكانت تُسمَّى في الإسلام \"مِلك يمين\"، حتَّى حُظرت العبوديَّة في الأراضي الإسلاميَّة في أوائل القرن العشرين.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0